import { render, staticRenderFns } from "./BaseSimpleModal.vue?vue&type=template&id=784f369e&scoped=true"
import script from "./BaseSimpleModal.vue?vue&type=script&lang=js"
export * from "./BaseSimpleModal.vue?vue&type=script&lang=js"
import style0 from "./BaseSimpleModal.vue?vue&type=style&index=0&id=784f369e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784f369e",
  null
  
)

export default component.exports